import { render, staticRenderFns } from "./SubscribeWithGoogleCTA.vue?vue&type=template&id=2a6540bf&scoped=true"
import script from "./SubscribeWithGoogleCTA.vue?vue&type=script&lang=js"
export * from "./SubscribeWithGoogleCTA.vue?vue&type=script&lang=js"
import style0 from "./SubscribeWithGoogleCTA.vue?vue&type=style&index=0&id=2a6540bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6540bf",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SecondaryLoadingSpinner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/SecondaryLoadingSpinner.vue').default})
